import { render, staticRenderFns } from "./OurSolution.vue?vue&type=template&id=546230a3&lang=html&"
import script from "./OurSolution.vue?vue&type=script&lang=js&"
export * from "./OurSolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports